/* Bodega Odara — catálogo con datos vivos de la tienda y carrito real.

   Los productos no vienen escritos en la página: se piden a la colección
   `outlet` con la vista `datos`, que es la única forma de conocer el
   inventario real. Así el precio y las piezas que ve el cliente son las que
   hay en ese momento, no una copia de cuando se publicó la página. */
(function () {
  "use strict";

  var GLIFO = {
    "Secadoras": "g-secadora", "Máquinas y recortadoras": "g-maquina",
    "Planchas": "g-plancha", "Tenazas y rizadores": "g-tenaza",
    "Cepillos de aire": "g-cepillo", "Lámparas y pulidoras": "g-lampara",
    "Fundidores y depiladoras": "g-fundidor", "Accesorios": "g-accesorio",
    "Mascotas": "g-mascota", "Combos": "g-combo"
  };
  var CATS = [
    { k: "barberia",   n: "Barbería",   d: "Máquinas, recortadoras y shavers", g: "g-maquina" },
    { k: "cabello",    n: "Cabello",    d: "Secadoras, planchas y tenazas",    g: "g-secadora" },
    { k: "unas",       n: "Uñas",       d: "Lámparas UV/LED y pulidoras",      g: "g-lampara" },
    { k: "depilacion", n: "Depilación", d: "Fundidores de cera y depiladoras", g: "g-fundidor" },
    { k: "accesorios", n: "Accesorios", d: "Esterilizadores y complementos",   g: "g-accesorio" },
    { k: "mascotas",   n: "Mascotas",   d: "Cortadoras y pulidoras para mascota", g: "g-mascota" }
  ];

  var LOGOS = window.BODEGA_LOGOS || {};

  /* Shopify guarda el vendor en mayúsculas ("BABYLISS PRO") y la marca se
     escribe de otra forma de cara al cliente. Se busca sin distinguir
     mayúsculas y se muestra el nombre bien escrito. */
  var LOGO_POR_CLAVE = {}, NOMBRE_POR_CLAVE = {};
  Object.keys(LOGOS).forEach(function (nombre) {
    var clave = nombre.toUpperCase().replace(/[^A-Z0-9]/g, "");
    LOGO_POR_CLAVE[clave] = LOGOS[nombre];
    NOMBRE_POR_CLAVE[clave] = nombre;
  });
  /* La tienda escribe algunas marcas distinto al nombre comercial:
     el vendor es GAMA y la marca se llama GA.MA Italy. */
  var ALIAS = { "GAMA": "GAMAITALY", "GAMAITALYPROFESSIONAL": "GAMAITALY",
                "BABYLISS": "BABYLISSPRO", "WAHLIB": "WAHL", "TIMCOL": "TIMCO",
                "REVLONIB": "REVLON" };
  var clave = function (m) {
    var k = String(m || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    return ALIAS[k] || k;
  };
  var logoDe = function (m) { return LOGO_POR_CLAVE[clave(m)]; };
  var nombreDe = function (m) {
    if (NOMBRE_POR_CLAVE[clave(m)]) return NOMBRE_POR_CLAVE[clave(m)];
    return String(m || "").replace(/\S+/g, function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    });
  };
  var COLECCION = window.BODEGA_COLECCION || "outlet";

  var estado = { cat: "", marca: "", texto: "", orden: "ahorro", pocas: false };
  var PRODUCTOS = [];
  var carrito = { items: [] };

  var pesos = function (n) { return "$" + Math.round(n).toLocaleString("es-MX"); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };
  var $ = function (id) { return document.getElementById(id); };

  /* ── Datos ─────────────────────────────────────────────────────────── */
  function traerPagina(n) {
    // Sin cabecera Accept a propósito: si se pide JSON, Shopify contesta con
    // el JSON de su API y se salta la vista `datos`, que es la que trae stock.
    return fetch("/collections/" + COLECCION + "?view=datos&page=" + n)
      .then(function (r) {
        if (!r.ok) throw new Error("la vista de datos respondió " + r.status);
        return r.text();
      })
      .then(function (t) {
        try { return JSON.parse(t); }
        catch (e) { throw new Error("la vista de datos no devolvió JSON válido"); }
      });
  }

  function cargarCatalogo() {
    return traerPagina(1).then(function (d) {
      var todo = d.productos.slice();
      var faltan = [];
      for (var i = 2; i <= d.paginas; i++) faltan.push(traerPagina(i));
      return Promise.all(faltan).then(function (resto) {
        resto.forEach(function (r) { todo = todo.concat(r.productos); });
        return todo.map(function (p) {
          return {
            id: p.id, sku: p.sku, t: p.titulo, h: p.handle, m: p.marca,
            c: p.tipo, o: p.oficio || "accesorios",
            po: p.precio, pl: p.lista, a: Math.max(0, p.lista - p.precio),
            mn: nombreDe(p.marca),
            d: p.lista > 0 ? Math.round((1 - p.precio / p.lista) * 100) : 0,
            s: p.stock, disp: p.disponible, img: p.imagen
          };
        });
      });
    });
  }

  /* ── Carrito real de Shopify ───────────────────────────────────────── */
  function leerCarrito() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; pintarCarrito(); avisarAlTema(c); return c; });
  }

  function agregar(id, boton) {
    boton.disabled = true;
    var previo = boton.textContent;
    boton.textContent = "Agregando…";
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "No se pudo agregar"); });
      return r.json();
    }).then(function () {
      boton.textContent = "Agregado ✓";
      boton.classList.add("listo");
      return leerCarrito().then(function () { abrir(true); });
    }).catch(function (e) {
      boton.textContent = "No disponible";
      setTimeout(function () { boton.textContent = previo; boton.classList.remove("listo"); }, 2200);
      console.warn("bodega:", e.message);
    }).finally(function () { boton.disabled = false; });
  }

  function cambiarCantidad(clave, cantidad) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: clave, quantity: cantidad })
    }).then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; pintarCarrito(); avisarAlTema(c); pintar(); });
  }

  /* ── Pintado ───────────────────────────────────────────────────────── */
  function arte(p, clase) {
    if (p.img) return '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" loading="lazy">';
    return '<svg class="' + clase + '" viewBox="0 0 100 100" aria-hidden="true"><use href="#' +
           (GLIFO[p.c] || "g-accesorio") + '"></use></svg>';
  }

  /* `salvo` deja fuera una dimensión del filtro. Sirve para contar cuántos
     quedarían al elegir cada marca SIN mentir: si ya hay una categoría puesta,
     el número de una marca tiene que reflejar esa categoría, no el catálogo
     entero. Es lo que hacía que una marca con «(2)» devolviera cero. */
  function aplica(p, salvo) {
    var q = estado.texto.trim().toLowerCase();
    if (salvo !== "cat" && estado.cat && p.o !== estado.cat) return false;
    if (salvo !== "marca" && estado.marca && p.m !== estado.marca) return false;
    if (salvo !== "pocas" && estado.pocas && p.s > 5) return false;
    if (salvo !== "texto" && q && (p.t + " " + p.sku).toLowerCase().indexOf(q) === -1) return false;
    return true;
  }

  function cuantosCon(dimension, valor) {
    return PRODUCTOS.filter(function (p) {
      if (!aplica(p, dimension)) return false;
      if (dimension === "marca") return p.m === valor;
      if (dimension === "cat") return p.o === valor;
      if (dimension === "pocas") return p.s <= 5;
      return true;
    }).length;
  }

  function filtrar() {
    var lista = PRODUCTOS.filter(function (p) { return aplica(p, null); });
    var cmp = {
      ahorro: function (a, b) { return b.a - a.a; },
      barato: function (a, b) { return a.po - b.po; },
      caro:   function (a, b) { return b.po - a.po; },
      stock:  function (a, b) { return b.s - a.s; }
    }[estado.orden];
    return lista.sort(cmp);
  }

  function tarjeta(p, i) {
    var pocas = p.s > 0 && p.s <= 5;
    var lleno = Math.min(100, Math.max(7, Math.round(p.s / 60 * 100)));
    var agotado = !p.disp || p.s <= 0;
    return '<article class="tarjeta" style="animation-delay:' + (Math.min(i, 20) * 28) + 'ms">' +
      '<a class="foto" href="/products/' + esc(p.h) + '" aria-label="' + esc(p.t) + '">' +
        '<span class="desc-badge">−' + p.d + '%</span>' +
        (pocas ? '<span class="pocas-badge">Quedan ' + p.s + '</span>' : '') +
        arte(p, "glifo-p") +
        (p.img ? '' : '<span class="pendiente">' + esc(p.c) + '</span>') +
      '</a>' +
      '<div class="info">' +
        '<span class="marca">' + esc(p.mn) + '</span>' +
        '<h3><a href="/products/' + esc(p.h) + '">' + esc(p.t) + '</a></h3>' +
        '<div class="dinero"><span class="antes">' + pesos(p.pl) + '</span>' +
          '<span class="ahora">' + pesos(p.po) + '</span></div>' +
        '<span class="ganas">Ahorras ' + pesos(p.a) + '</span>' +
        '<div class="medidor"><span class="riel"><i class="' + (pocas ? "poco" : "") +
          '" style="width:' + lleno + '%"></i></span><span class="cuantas">' + p.s + ' pz</span></div>' +
        '<button class="btn-add" data-id="' + p.id + '"' + (agotado ? " disabled" : "") + '>' +
          (agotado ? "Agotado" : "Agregar") + '</button>' +
      '</div></article>';
  }

  function refrescarConteos() {
    // Marcas: el número de cada una cuenta ya con los demás filtros puestos.
    var sel = $("marca");
    if (sel) {
      [].forEach.call(sel.options, function (o) {
        if (!o.value) return;
        var n = cuantosCon("marca", o.value);
        o.textContent = nombreDe(o.value) + " (" + n + ")";
        o.disabled = n === 0 && o.value !== estado.marca;
      });
    }
    // Categorías: igual, y se apaga la que no dejaría nada.
    document.querySelectorAll(".cat").forEach(function (b) {
      var n = cuantosCon("cat", b.dataset.k);
      var et = b.querySelector(".cuenta");
      if (et) et.textContent = n + (n === 1 ? " modelo" : " modelos");
      b.classList.toggle("apagada", n === 0 && estado.cat !== b.dataset.k);
    });
    var bp = $("pocas");
    if (bp) {
      var n = cuantosCon("pocas");
      bp.classList.toggle("apagada", n === 0 && !estado.pocas);
    }
  }

  function pintarActivos() {
    var caja = $("activos");
    if (!caja) return;
    var chips = [];
    if (estado.cat) {
      var c = CATS.filter(function (x) { return x.k === estado.cat; })[0];
      chips.push({ tipo: "cat", et: c ? c.n : estado.cat });
    }
    if (estado.marca) chips.push({ tipo: "marca", et: nombreDe(estado.marca) });
    if (estado.pocas) chips.push({ tipo: "pocas", et: "Quedan pocas" });
    if (estado.texto.trim()) chips.push({ tipo: "texto", et: '"' + estado.texto.trim() + '"' });

    caja.innerHTML = chips.length
      ? '<span class="et-activos">Filtros:</span>' + chips.map(function (c) {
          return '<button class="chip-activo" data-quita="' + c.tipo + '">' +
                 esc(c.et) + ' <span aria-hidden="true">×</span></button>';
        }).join("") +
        '<button class="limpiar-todo" data-quita="todo">Quitar todos</button>'
      : "";
    caja.classList.toggle("hay", chips.length > 0);
  }

  function limpiar(tipo) {
    if (tipo === "todo") {
      estado.cat = ""; estado.marca = ""; estado.pocas = false; estado.texto = "";
    } else if (tipo === "cat") { estado.cat = ""; }
    else if (tipo === "marca") { estado.marca = ""; }
    else if (tipo === "pocas") { estado.pocas = false; }
    else if (tipo === "texto") { estado.texto = ""; }

    var b = $("buscar"); if (b) b.value = estado.texto;
    var m = $("marca");  if (m) m.value = estado.marca;
    var bp = $("pocas");
    if (bp) { bp.classList.toggle("viva", estado.pocas); bp.setAttribute("aria-pressed", String(estado.pocas)); }
    document.querySelectorAll(".cat").forEach(function (c) {
      c.setAttribute("aria-pressed", String(c.dataset.k === estado.cat && !!estado.cat));
    });
    pintar();
  }

  /* Al filtrar, la retícula suele quedar fuera de la vista y da la impresión
     de que no pasó nada. Se acerca la barra de control al aplicar un filtro. */
  function acercarResultados() {
    var ctrl = document.querySelector(".bdg-outlet .control");
    if (!ctrl) return;
    var y = ctrl.getBoundingClientRect().top + window.scrollY - 64;
    if (window.scrollY < y - 40) window.scrollTo({ top: y, behavior: "smooth" });
  }

  function pintar() {
    var lista = filtrar();
    $("rejilla").innerHTML = lista.length
      ? lista.map(tarjeta).join("")
      : '<div class="nada"><h3>Nada con esta combinación</h3>' +
        "<p>" + esc(motivoVacio()) + "</p>" +
        '<button class="btn btn-naranja" data-quita="todo" style="margin-top:16px">Quitar los filtros</button></div>';
    var pz = lista.reduce(function (s, p) { return s + p.s; }, 0);
    $("marcador").innerHTML = "<b>" + lista.length + "</b> modelos · <b>" +
      pz.toLocaleString("es-MX") + "</b> piezas";
    refrescarConteos();
    pintarActivos();
  }

  /* Cuando no hay resultados, decir POR QUÉ: casi siempre es que la marca
     elegida no tiene nada en la categoría que quedó puesta más arriba. */
  function motivoVacio() {
    if (estado.marca && estado.cat) {
      var c = CATS.filter(function (x) { return x.k === estado.cat; })[0];
      return nombreDe(estado.marca) + " no tiene equipo de " +
             (c ? c.n.toLowerCase() : "esa categoría") + " en la bodega.";
    }
    if (estado.texto.trim()) return "No encontramos «" + estado.texto.trim() + "» en la bodega.";
    if (estado.marca) return nombreDe(estado.marca) + " no tiene piezas con esos filtros.";
    return "Prueba quitando algún filtro.";
  }

  function pintarCarrito() {
    var n = carrito.item_count || 0;
    var burbuja = $("numCarrito");
    if (burbuja) burbuja.textContent = n;
    var lista = $("listaCarrito"), pie = $("pieCarrito");
    if (!lista) return;
    if (!n) {
      lista.innerHTML = '<div class="vacio-c">Tu carrito está vacío.</div>';
      pie.innerHTML = "";
      return;
    }
    lista.innerHTML = carrito.items.map(function (it) {
      var ahorro = it.original_line_price - it.final_line_price;
      return '<div class="reng"><span class="mini">' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '') + '</span>' +
        '<div><h4>' + esc(it.product_title) + '</h4>' +
        '<span class="p">' + it.quantity + " × " + pesos(it.price / 100) + '</span><br>' +
        '<button class="quitar" data-clave="' + esc(it.key) + '">Quitar</button></div>' +
        '<strong>' + pesos(it.final_line_price / 100) + '</strong></div>';
    }).join("");
    var ahorro = carrito.items.reduce(function (s, it) {
      return s + (it.original_line_price - it.final_line_price);
    }, 0);
    pie.innerHTML =
      (ahorro > 0 ? '<div class="ahorro-tot">Estás ahorrando ' + pesos(ahorro / 100) + "</div>" : "") +
      '<div class="suma"><span class="et">Total</span><span class="v">' +
        pesos(carrito.total_price / 100) + "</span></div>" +
      '<a class="btn btn-naranja" style="width:100%" href="/checkout">Ir a pagar</a>';
  }

  /* El tema lleva su propio contador de carrito en el encabezado. Como aquí
     se agrega por la API y no por su formulario, hay que avisarle para que no
     se quede marcando cero mientras el carrito ya tiene piezas. */
  function avisarAlTema(cart) {
    var n = cart.item_count || 0;
    document.querySelectorAll(".cart-count, [data-cart-count]").forEach(function (e) {
      e.textContent = n;
      e.classList.toggle("cart-count--blank", n === 0);
      if (e.hasAttribute("data-cart-count")) e.setAttribute("data-cart-count", n);
    });
    ["cart:refresh", "cart:updated", "cart:change"].forEach(function (nombre) {
      document.dispatchEvent(new CustomEvent(nombre, { bubbles: true, detail: { cart: cart } }));
    });
    if (window.PubSub && typeof window.PubSub.publish === "function") {
      try { window.PubSub.publish("cart-update", { cart: cart }); } catch (e) {}
    }
  }

  function abrir(v) {
    $("cajon").classList.toggle("abierto", v);
    $("velo").classList.toggle("abierto", v);
  }

  /* ── Arranque ──────────────────────────────────────────────────────── */
  function montarFiltros() {
    var porMarca = {};
    PRODUCTOS.forEach(function (p) { porMarca[p.m] = (porMarca[p.m] || 0) + 1; });

    var tira = $("tiraMarcas");
    if (tira) {
      tira.innerHTML = Object.keys(porMarca)
        .sort(function (a, b) { return porMarca[b] - porMarca[a]; })
        .slice(0, 9).map(function (m) {
          var logo = logoDe(m), bonito = nombreDe(m);
          return '<span class="caja" title="' + esc(bonito) + " · " + porMarca[m] + ' modelos">' +
            (logo ? '<img src="' + logo + '" alt="' + esc(bonito) + '" loading="lazy">'
                  : '<span class="txt">' + esc(bonito) + "</span>") + "</span>";
        }).join("");
    }

    var rej = $("rejillaCat");
    if (rej) {
      rej.innerHTML = CATS.map(function (c) {
        var n = PRODUCTOS.filter(function (p) { return p.o === c.k; }).length;
        if (!n) return "";
        return '<button class="cat" data-k="' + c.k + '" aria-pressed="false">' +
          '<span class="glifo"><svg width="30" height="30" viewBox="0 0 100 100" aria-hidden="true">' +
          '<use href="#' + c.g + '"></use></svg></span>' +
          "<h3>" + c.n + "</h3><p>" + c.d + '</p><span class="cuenta">' + n + " modelos</span></button>";
      }).join("");
    }

    var sel = $("marca");
    if (sel) {
      Object.keys(porMarca).sort().forEach(function (m) {
        sel.insertAdjacentHTML("beforeend",
          '<option value="' + esc(m) + '">' + esc(nombreDe(m)) + " (" + porMarca[m] + ")</option>");
      });
    }
    var piezas = PRODUCTOS.reduce(function (s, p) { return s + p.s; }, 0);
    var ch = $("cuentaHero");
    if (ch) ch.textContent = "· " + piezas.toLocaleString("es-MX") + " piezas";
  }

  function eventos() {
    var rej = $("rejillaCat");
    if (rej) rej.addEventListener("click", function (e) {
      var b = e.target.closest(".cat"); if (!b) return;
      var ya = b.getAttribute("aria-pressed") === "true";
      rej.querySelectorAll(".cat").forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
      b.setAttribute("aria-pressed", ya ? "false" : "true");
      estado.cat = ya ? "" : b.dataset.k;
      pintar(); acercarResultados();
    });
    $("rejilla").addEventListener("click", function (e) {
      var b = e.target.closest(".btn-add"); if (!b) return;
      e.preventDefault();
      agregar(parseInt(b.dataset.id, 10), b);
    });
    // quitar un filtro desde los chips o desde el mensaje de vacío
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-quita]");
      if (!b) return;
      e.preventDefault();
      limpiar(b.dataset.quita);
    });
    $("listaCarrito").addEventListener("click", function (e) {
      var b = e.target.closest("[data-clave]"); if (!b) return;
      cambiarCantidad(b.dataset.clave, 0);
    });
    var bus = $("buscar");
    if (bus) bus.addEventListener("input", function (e) { estado.texto = e.target.value; pintar(); });
    var sm = $("marca");
    if (sm) sm.addEventListener("change", function (e) { estado.marca = e.target.value; pintar(); acercarResultados(); });
    var so = $("orden");
    if (so) so.addEventListener("change", function (e) { estado.orden = e.target.value; pintar(); });
    var bp = $("pocas");
    if (bp) bp.addEventListener("click", function (e) {
      estado.pocas = !estado.pocas;
      e.currentTarget.classList.toggle("viva", estado.pocas);
      e.currentTarget.setAttribute("aria-pressed", String(estado.pocas));
      pintar(); acercarResultados();
    });
    var ac = $("abrirCarrito");
    if (ac) ac.addEventListener("click", function () { abrir(true); });
    $("cerrarCarrito").addEventListener("click", function () { abrir(false); });
    $("velo").addEventListener("click", function () { abrir(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") abrir(false); });
  }

  function arrancar() {
    $("rejilla").innerHTML = '<div class="nada"><h3>Cargando la bodega…</h3></div>';
    cargarCatalogo().then(function (lista) {
      PRODUCTOS = lista;
      montarFiltros();
      eventos();
      pintar();
      return leerCarrito();
    }).catch(function (e) {
      console.error("bodega:", e);
      $("rejilla").innerHTML = '<div class="nada"><h3>No pudimos cargar el catálogo</h3>' +
        "<p>Recarga la página, por favor.</p></div>";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancar);
  } else { arrancar(); }
})();
